/**
 * @generated SignedSource<<2e0ae703be36640b47faa16223e3291c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type overviewPageQuery$variables = {
  boardId: string;
};
export type overviewPageQuery$data = {
  readonly jira: {
    readonly reportsPage: {
      readonly categories: ReadonlyArray<{
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"reportCategory_reportsOverviewPage">;
      } | null | undefined>;
    };
  };
};
export type overviewPageQuery = {
  response: overviewPageQuery$data;
  variables: overviewPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "overviewPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "concreteType": "ReportsPage",
                "kind": "LinkedField",
                "name": "reportsPage",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "ReportCategory",
                      "kind": "LinkedField",
                      "name": "categories",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v2/*: any*/),
                          "action": "THROW",
                          "path": "jira.reportsPage.categories.name"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "reportCategory_reportsOverviewPage"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.reportsPage.categories"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.reportsPage"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "overviewPageQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "ReportsPage",
            "kind": "LinkedField",
            "name": "reportsPage",
            "plural": false,
            "selections": [
              {
                "concreteType": "ReportCategory",
                "kind": "LinkedField",
                "name": "categories",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "concreteType": "JiraReport",
                    "kind": "LinkedField",
                    "name": "reports",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "url"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "imageUrl"
                      },
                      (v3/*: any*/)
                    ]
                  },
                  (v3/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8f42d6157668acf544508de6ddfe43cb",
    "id": null,
    "metadata": {},
    "name": "overviewPageQuery",
    "operationKind": "query",
    "text": "query overviewPageQuery($boardId:ID!){jira{reportsPage(boardId:$boardId){categories{name,...reportCategory_reportsOverviewPage,id}}}}fragment reportCard_reportsOverviewPage on JiraReport{name,description,url,imageUrl}fragment reportCategory_reportsOverviewPage on ReportCategory{name,reports{name,...reportCard_reportsOverviewPage,id}}"
  }
};
})();

(node as any).hash = "4f2dd6ad0e5d250339da7aca3700ae3a";

export default node;
